require('./blocks/about-promo.less');
require('./blocks/benefits/benefits');
require('./blocks/benefit.less');
require('./blocks/map-block.less');
require('./blocks/feedback-city/feedback-city');
require('./blocks/dealer-banner/dealer-banner.less');
require('./blocks/socials-widget/contacts-side/contacts-side.less');


// WEBPACK FOOTER //
// ./contacts.js